export const TypeEmployeurPrive = [
  'RepertoireDesMetiers',
  'RegistreDuCommerce',
  'MutualiteSocialeAgricole',
  'ProfessionLiberale',
  'Association',
  'AutreEmployeurPrive',
] as const

export type TypeEmployeurPrive = typeof TypeEmployeurPrive[number]

export const TypeEmployeurPriveLibelle: {
  [key in TypeEmployeurPrive]: string
} = {
  RepertoireDesMetiers:
    "11 - Entreprise inscrite au répertoire des métiers ou au registre des entreprises pour l'Alsace-Moselle",
  RegistreDuCommerce: '12 - Entreprise inscrite uniquement au registre du commerce et des sociétés',
  MutualiteSocialeAgricole: '13 - Entreprises dont les salariés relèvent de la mutualité sociale agricole',
  ProfessionLiberale: '14 - Profession libérale',
  Association: '15 - Association',
  AutreEmployeurPrive: '16 - Autre employeur privé',
} as const

export const TypeEmployeurPublic = {
  AutreEmployeurPublic: 'AutreEmployeurPublic',
  EtablissementPublicIndustrielCommercial: 'EtablissementPublicIndustrielCommercial',
} as const

export type TypeEmployeurPublic = keyof typeof TypeEmployeurPublic

export const TypeEmployeurPublicLibelle: {
  [key in TypeEmployeurPublic]: string
} = {
  AutreEmployeurPublic: '29 - Autre employeur public',
  EtablissementPublicIndustrielCommercial: '30 - Etablissement public industriel et commercial',
} as const
